import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PagamentoDespesaDetalharComponent } from './pagamento-despesa-detalhar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: PagamentoDespesaDetalharComponent }
    ])],
    exports: [RouterModule]
})
export class PagamentoDespesaDetalharRoutingModule { }
